import type { App } from 'vue'
import 'ant-design-vue/dist/antd.less'
import '@tmp/site-common/dist/es/index.css'
const plugins: any[] = []

export default function registerPlugin(app: App) {
  plugins.forEach((p) => app.use(p))
}
